import HRStars from './SkillHrStars.js'
import MainSkillCheckbox from './SkillMainCheckbox.js'
import MandatorySkillCheckbox from './SkillMandatoryCheckbox.js'

export default class SkillNode extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: true
    };
  }

  render () {
    // use candidate_stars as hr_stars if it is Portal
    let children, showStars;
    if (gon.application.portal) {
      showStars = this.props.candidate_stars !== undefined;
    } else {
      showStars = this.props.hr_stars !== undefined;
    }
    if (this.props.children && this.props.children.length) {
      children = this.props.children.map((node, index) => {
        return <SkillNode key={node.skill_id} hideCandidateStars={this.props.hideCandidateStars} {...node} />
      });
    }
    return (
      <li data-skill-id={this.props.skill_id}>
        <div className={"line " + this._toggleClass()}>
          <div onClick={children && children.length && this._toggle.bind(this)} className='skill-name'>
            <span title={this._tooltip()}>{this._name()}</span>
          </div>
          {showStars && !this.props.hideCandidateStars && <div className={`skill-candidate ${this.props.input_type}-${this.props.candidate_stars}`} />}
          {showStars && <HRStars {...this.props} />}
          {showStars && this._skillCheckbox()}
        </div>
        {children && children.length && <ul>{children}</ul>}
      </li>
    )
  }

  _name () {
    if (this.props.name) {
      return this.props.name.replace(/\u00a0/g, ' ')
    }
  }

  _toggleClass () {
    if (this.props.children && this.props.children.length) {
      return this.state.visible ? 'open' : 'closed';
    } else {
      return '';
    }
  }

  _tooltip () {
    if (this.props.tooltip)
      return this.props.tooltip.replace(/,/g, ' → ')
  }

  _skillCheckbox () {
    if (this.props.hasOwnProperty('main')) {
      return <MainSkillCheckbox {...this.props} />
    } else if (this.props.hasOwnProperty('mandatory')) {
      return <MandatorySkillCheckbox {...this.props} />
    }
  }

  _toggle () {
    this.setState({ visible: !this.state.visible })
  }
}

SkillNode.propTypes = {
  skill_id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.array
};
